import { getLeadApiResources } from "../../utils/api";

export const GET_LEAD_API_RESOURCES_FETCHING = 'GET_LEAD_API_RESOURCES_FETCHING';
export const GET_LEAD_API_RESOURCES_FAIL = 'GET_LEAD_API_RESOURCES_FAIL';
export const GET_LEAD_API_RESOURCES_SUCCESS = 'GET_LEAD_API_RESOURCES_SUCCESS';

export const getLeadApiResourcesFetchingAction = () => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch({type: GET_LEAD_API_RESOURCES_FETCHING});
    getLeadApiResources(state.auth.user.accessToken)
      .then(({data}) => {
        dispatch(getLeadApiResourcesSuccess(data.data.resources));
      })
      .catch(e => {
        dispatch(getLeadApiResourcesFail(e));
      })
  }
};

export const getLeadApiResourcesFail = (e) => {
  return {type: GET_LEAD_API_RESOURCES_FAIL, payload: {message: e?.message}}
};

export const getLeadApiResourcesSuccess = (leadApiResources) => {
  return {type: GET_LEAD_API_RESOURCES_SUCCESS, payload: {leadApiResources}}
};
